import * as Yup from "yup";

export const projectEditionSchema = Yup.object({
    name: Yup.string().required("Nome obrigatório."),
    description: Yup.string().required("Descrição obrigatória."),
    amount: Yup.string().required("Valor obrigatório."),
    observation: Yup.string().optional(),
    deadline: Yup.date().required("Data limite obrigatória"),
});
